import * as Event from './../../_function/event.js';
import * as ModuleClass from './../../_function/class.js';
import * as Element from './../../_function/element.js';

// =============================================================================
// contact_form.js

var contact_form__info = document.getElementById('contact_form__info');
var contact_form__message__input = document.getElementById('contact_form__message__input');
var contact_form__message = document.getElementById('contact_form__message');
var contact_form__message__notice__empty = document.getElementById('contact_form__message__notice__empty');
var contact_form__message__submit = document.getElementById('contact_form__message__submit');

// height update

function updateheights() {
  contact_form__message__input.style.minHeight = ( parseFloat( Element.getElementStyle( contact_form__info ).height) - 80 ) + 'px';
}

var contactTimeout = [];

Event.addEvent( 'resize', window, function(event) {
  for ( var i = 0; i < 100; i++ ) {
    if ( contactTimeout[ i ] !== 'undefined' ) clearTimeout( contactTimeout[ i ] );
    contactTimeout[ i ] = setTimeout( updateheights, i * 10 );
  }
} );

updateheights();

// message interface

function initDisabledShake( event ) {
  document.dispatchEvent( new CustomEvent( "updateDisabledShake", { detail: {
    event: event, // not optional, needed to access the parent event in the custom event
    force: true // will not check for disabled inputs before adding disabled events
  } } ) );
}

function updateSendButton() {
  if ( contact_form__message__input.value )
  {
    contact_form__message__submit.removeAttribute('disabled');
    contact_form__message__notice__empty.style.display = 'none';
  }
  else
  {
    contact_form__message__submit.disabled = 'disabled';
    contact_form__message__notice__empty.style.display = '';
    initDisabledShake();
  }
}

Event.addEvent( 'keyup', contact_form__message__input, function( event ) {
  updateSendButton();
} );

function sendMessage( event ) {
  contact_form__message__input.disabled = 'disabled';
  ModuleClass.addClass( contact_form__message, 'contact_form__message--processing' );
  initDisabledShake( event );

  setTimeout( function() {
    contact_form__message__submit.disabled = 'disabled';
    initDisabledShake( event );
  }, 250 );

  setTimeout( function() {
    contact_form__message__input.value = ' ';
    ModuleClass.removeClass( contact_form__message, 'contact_form__message--processing' );
    ModuleClass.addClass( contact_form__message, 'contact_form__message--processed' );
  }, 3000 );

  setTimeout( function() {
    contact_form__message__input.value = '';
    contact_form__message__input.removeAttribute('disabled');
    ModuleClass.removeClass( contact_form__message, 'contact_form__message--processed' );
    updateSendButton();
  }, 6000 );
}

Event.addEvent( 'click', contact_form__message__submit, function( event ) {
  sendMessage( event );
} );

function initMessageInterface() {
  updateSendButton();
  initDisabledShake();
}

initMessageInterface();
